(function () {
  const SELECTED = 'fq-card--selected';
  const HIDDEN = 'hidden';

  document.querySelectorAll('[data-fragrance-quiz]').forEach(init);

  function init(root) {
    const steps = Array.from(root.querySelectorAll('.fq-step'));
    const continueBtn = root.querySelector('.fq-continue');
    const backBtn = root.querySelector('.fq-back');
    const tabsBar = root.querySelector('[data-fq-tabs]');
    const tabs = Array.from(root.querySelectorAll('[data-fq-tab]'));
    const restartBtn = root.querySelector('[data-fq-restart]');
    const emptyMessage = root.querySelector('[data-fq-empty]');
    if (steps.length < 2 || !continueBtn) return;

    let index = 0;


    function selected(at) {
      const step = steps[at == null ? index : at];
      return step ? step.querySelector('.fq-card.' + SELECTED) : null;
    }

    function reveal(step, parentId) {
      let matches = 0;

      step.querySelectorAll('[data-parent]').forEach(function (item) {
        const isMatch = item.dataset.parent === parentId;
        item.classList.toggle(HIDDEN, !isMatch);
        item.classList.remove(SELECTED);
        if (isMatch) matches += 1;
      });

      return matches;
    }

    function goTo(next) {
      if (!steps[next]) return;

      steps[index].classList.add(HIDDEN);
      steps[next].classList.remove(HIDDEN);
      index = next;
      sync();
    }

    function sync() {
      const isLast = index === steps.length - 1;

      continueBtn.classList.toggle(HIDDEN, isLast);
      continueBtn.disabled = !isLast && !selected();
      if (backBtn) backBtn.classList.toggle(HIDDEN, index === 0 || isLast);

      if (tabsBar) tabsBar.classList.toggle(HIDDEN, isLast);
      if (restartBtn) restartBtn.classList.toggle(HIDDEN, !isLast);

      tabs.forEach(function (tab, i) {
        tab.classList.toggle('fq-tab--current', i === index);
        tab.classList.toggle('fq-tab--done', i < index);
        tab.disabled = i > index;

        const value = tab.querySelector('[data-fq-tab-value]');
        if (!value) return;

        const card = i <= index ? selected(i) : null;
        const title = card && card.querySelector('.fq-card__title');
        value.textContent = title ? title.textContent.trim() : '';
      });
    }

    root.addEventListener('click', function (event) {
      const card = event.target.closest('.fq-card');
      if (!card || !root.contains(card)) return;

      card.closest('.fq-step')
        .querySelectorAll('.fq-card.' + SELECTED)
        .forEach(function (item) {
          item.classList.remove(SELECTED);
        });

      card.classList.add(SELECTED);
      sync();
    });

    continueBtn.addEventListener('click', function () {
      const card = selected();
      const nextStep = steps[index + 1];
      if (!card || !nextStep) return;

      const nextIsResult = index + 1 === steps.length - 1;

      if (nextIsResult) {
        const pageLink = nextStep.querySelector(
          '[data-parent="' + card.dataset.id + '"] .fq-result__page-button'
        );
        if (pageLink && pageLink.href) {
          window.location.href = pageLink.href;
          return;
        }
      }

      const matches = reveal(nextStep, card.dataset.id);

      if (!matches && !nextIsResult) {
        console.warn('[fragrance-quiz] "' + card.dataset.id + '" ke aage koi option set nahi hai');
        return;
      }

      if (emptyMessage) emptyMessage.classList.toggle(HIDDEN, matches > 0);
      goTo(index + 1);
    });


    if (backBtn) {
      backBtn.addEventListener('click', function () {
        goTo(index - 1);
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        goTo(i);

        const grid = steps[i].querySelector('.fq-grid') || steps[i];
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        root.querySelectorAll('.fq-card.' + SELECTED).forEach(function (item) {
          item.classList.remove(SELECTED);
        });

        root.querySelectorAll('[data-parent]').forEach(function (item) {
          item.classList.add(HIDDEN);
        });

        goTo(0);
      });
    }

    sync();
  }
})();
